<template>
  <div>
    <div class="headerTop">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in imgList" :key="item">
          <img :src="item.img" class="slider_img">
          <div class="topFont">
            <div class="topFontO">易凡云CDN</div>
            <div class="topFontT">融合主流CDN厂商节点</div>
            <div class="topFontTh">国内1000+节点智能分发，最高业务带宽峰值可达T级</div>
            <el-button
              type="primary"
              class="header-title"
              style="color:#fff;background: #0066FF;"
            >立即免费开通</el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="headerTopCenter">
        <div class="headerTopBottom">
          <span class="headerTopBottomFont">智能融合CDN</span>
          <span class="headerTopBottomFonts">华为云线路携手企业上云加速</span>
        </div>
        <span style="height: 67px;border-right: 2px solid #E2E6F0;"></span>
        <div class="headerTopBottom">
          <span class="headerTopBottomFont">调度能力</span>
          <span class="headerTopBottomFonts">实时响应+TL秒级切换</span>
        </div>
        <span style="height: 67px;border-right: 2px solid #E2E6F0;"></span>
        <div class="headerTopBottom">
          <span class="headerTopBottomFont">配置修改</span>
          <span class="headerTopBottomFonts">多厂商配置自动同步</span>
        </div>
        <span style=" height: 67px;border-right: 2px solid #E2E6F0;"></span>
        <div class="headerTopBottom">
          <span class="headerTopBottomFont">账单统计</span>
          <span class="headerTopBottomFonts">多厂商实时统一结算</span>
        </div>
      </div>
    </div>
    <div class="solve head-label" style="margin-top:168px;margin-bottom:58px">
      <div style="text-align: center;" class="font_size_24">易凡云融合CDN控制台</div>
    </div>
    <!-- 易凡云融合CDN控制台 -->
    <div class="product_pcs">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_10">{{manages[0].title}}</div>
            <div style=" display: flex;flex-direction: row;margin-top:90px">
              <div v-for="(item,index) in manages[1].imgDetail" :key="index">
                <div
                  style="display: flex;flex-direction: column;align-items: center;margin-left: 40px;"
                >
                  <img style=" width: 53px;height: 38px;" :src="item.img" alt="" class="">
                  <span style="margin: 15px 0;">{{item.title}}</span>
                  <span>{{item.content}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img :src="manages[0].img[0]" class="product_pc_img">
        </el-col>
      </el-row>
    </div>
	
    <!-- 易凡云智能融合CDN -->
    <div class="product_mobile">
      <el-row>
        <el-col :xs="24" :sm="12">
          <img :src="products[0].img[0]" class="product_mobile_img" ref="product_mobile_img">
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="product_mobile_content" ref="product_mobile_content">
            <div class="product_mobile_title font_size_30">{{products[0].title}}</div>
            <div class="product_mobile_title font_size_40">{{products[0].titleTwo}}</div>
            <div v-for="(item,index) in products[0].content" :key="index" style="width:533px">
              <div class="product_font_style product_mobile_content_one">{{item}}</div>
            </div>
            <el-button
              type="primary"
              class="header-title"
              style="color:#fff;background: #0066FF;margin-top:57px"
            >立即免费开通</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 融合CDN架构-->
    <div id="融合CDN架构" class="product_spec_title head-label">
      <div style="text-align: center;" class="font_size_24">融合CDN架构</div>
    </div>
    <div>
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="product_pc_box">
            <div v-for="(item,index) in specList" :key="index">
              <div class="product_pc_boxDetail">
                <p>{{item.title}}</p>
                <span>{{item.contents}}</span>
                <img :src="item.img" alt="">
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 管理平台能力 -->
    <div class="product_mobiless">
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="glbox_List">
            <p>{{glList.title}}</p>
            <span>{{glList.contents}}</span>
            <div class="glbox_Detail">
              <div v-for="(item,index) in glList.glListDetail" :key="index">
                <div
                  class="glbox_Detail_box"
                  v-on:mouseover="changeActive($event)"
                  v-on:mouseout="removeActive($event)"
                >
                  <div class="glbox_Detail_boxLeft">
                    <span class="glbox_Detail_boxLeftt">{{item.title}}</span>
                    <span class="glbox_Detail_boxLeftb">{{item.contents}}</span>
                  </div>
                  <img :src="item.img" alt="">
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 服务流程 -->
    <div class="product_Server">
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="sebox_List">
            <p>{{serveList.title}}</p>
            <span>{{serveList.contents}}</span>
            <div class="sebox_Detail">
              <img src="../assets/imgs/servebag.png" alt="" class="sebox_Detailimg">
              <div class="dog_l">
                <img src="../assets/imgs/seone.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>区域ISP</span>
              </div>
              <div class="dog_lt">
                <img src="../assets/imgs/setwo.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>下载速度统计</span>
              </div>
              <div class="dog_lth">
                <img src="../assets/imgs/sethr.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>带宽峰值</span>
              </div>
              <div class="dog_lfo">
                <img src="../assets/imgs/sefou.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>查询统计</span>
              </div>
              <div class="dog_lfi">
                <img src="../assets/imgs/sefiv.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>请求流量</span>
              </div>
              <div class="dog_lsi">
                <img src="../assets/imgs/sesix.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>命中统计</span>
              </div>
              <div class="dog_lse">
                <img src="../assets/imgs/seseiv.png" alt="" style=" width: 103px;height:100px">
                <div style="    position: relative;">
                  <div class="dog_ld"></div>
                  <div class="dog_lds"></div>
                </div>
                <span>质量统计</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      imgList: [
        {
          img: [require("../assets/imgs/homeBa.png")]
        },
        {
          img: [require("../assets/imgs/successBag.png")]
        },
        {
          img: [require("../assets/imgs/solutionOne.png")]
        }
      ],
      products: [
        {
          img: [require("../assets/imgs/bannerCenterBgTwo.png")],
          title: "易凡云智能融合CDN",
          titleTwo: "融合CDN智能分发",
          content: [
            "易凡云融合20+CDN平台，50T+带宽资源池、3000+节点，全网调度，服务保障。 ",
            " 一次适配，享受全网优质资源服务。有问题，找易凡云。",
            "遇故障，先切换，用户无感知。"
          ]
        }
      ],
      manages: [
        {
          img: [require("../assets/imgs/bannerCenterBg.png")],
          title:
            "易凡云融合CDN控制平台，支持单厂商、多厂商自动配置的同步处理，系统不定期检测节点状态、域名异常状态第一时间进行异常报警，根据不同业务状态进行多厂商节点调度，为各行业提供成本优化且稳定的加速服务。"
        },
        {
          imgDetail: [
            {
              img: [require("../assets/imgs/jd.png")],
              title: "节点",
              content: "华为云、火山云等行业代表"
            },
            {
              img: [require("../assets/imgs/dd.png")],
              title: "调度",
              content: "系统自动无感知切换"
            },
            {
              img: [require("../assets/imgs/yc.png")],
              title: "异常",
              content: "不定期自动巡检通知"
            }
          ]
        }
      ],
      specList: [
        {
          img: require("../assets/imgs/boxOne.png"),
          title: "智能调度",
          contents:
            "易凡云基于监控分析系统理论，对可用性故障节点故障、异常状态码等按设置的闽值自动切换;对于网络抖动、下载速度、响应时间等异常情形进行人工优化。"
        },
        {
          img: require("../assets/imgs/boxTwo.png"),
          title: "监控体系",
          contents:
            "易凡云自由分布式全网实时监控，结合第三方监控数据、渠道监控数据、客户监控数据，全方位实时监控网络状况。"
        },
        {
          img: require("../assets/imgs/boxThree.png"),
          title: "聚合BOSS系统",
          contents:
            "掌控智能融合CDN平台的运营状态，包括基础数据、资源、统计、内容管理、质量数据、API体系状况等，透明服务，极致体验。"
        }
      ],
      glList: {
        title: "管理平台能力",
        contents:
          "易凡云融合CDN控制平台自主研发支持跨厂商API接口的调度能力，实现全部功能的多厂商配置更新。完善客户体验度保障业务稳定运行。",
        glListDetail: [
          {
            img: require("../assets/imgs/glone.png"),
            title: "调度能力",
            contents: "秒级切换"
          },
          {
            img: require("../assets/imgs/gltw.png"),
            title: "配置修改",
            contents: "自动同步"
          },
          {
            img: require("../assets/imgs/glth.png"),
            title: "账单统计",
            contents: "多厂商统一结算"
          },
          {
            img: require("../assets/imgs/glfo.png"),
            title: "管理控制",
            contents: "用户全面自由管理"
          },
          {
            img: require("../assets/imgs/glfi.png"),
            title: "异常通知",
            contents: "自动巡检通知"
          },
          {
            img: require("../assets/imgs/glsi.png"),
            title: "节点支撑",
            contents: "华为云、火山云、 阿里云 等知名厂商"
          }
        ]
      },
      serveList: {
        title: "服务流程",
        contents:
          "10000多家企事业单位认可的移动应用构建流程，科学组织，提高开发效率"
      }
    };
  },
  methods: {
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "492px";
      } else {
        return "250px";
      }
    },
    changeActive(e) {
      e.currentTarget.className = "active";
    },
    removeActive(e) {
      e.currentTarget.className = "glbox_Detail_box";
    }
  },
  computed: {}
};
</script>

<style scoped>
.el-carousel {
  width: 1920px;
  /* height: 492px; */
}
/deep/ .el-carousel__container {
  height: 492px !important;
}
.sebox_List {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sebox_List p {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin-top: 0;
}
.sebox_List span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
}
.sebox_List .sebox_Detail {
  position: relative;
}
.sebox_List .sebox_Detail .sebox_Detailimg {
  width: 1355px;
  height: 161px;
  margin-top: 173px;
}
.sebox_List .sebox_Detail .dog_l {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 49%;
  left: 4%;
}
.sebox_List .sebox_Detail .dog_lt {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 42%;
  left: 19%;
}
.sebox_List .sebox_Detail .dog_lth {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 41%;
  left: 35%;
}
.sebox_List .sebox_Detail .dog_lfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 22%;
  left: 50%;
}
.sebox_List .sebox_Detail .dog_lfi {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 32%;
  left: 63%;
}
.sebox_List .sebox_Detail .dog_lsi {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 76%;
}
.sebox_List .sebox_Detail .dog_lse {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 88%;
}
.sebox_List .sebox_Detail .dog_ld {
  width: 24px;
  height: 24px;
  background: rgb(0, 102, 255);
  opacity: 0.4;
  border-radius: 50%;
}
.sebox_List .sebox_Detail .dog_lds {
  width: 12px;
  border-radius: 50%;
  height: 12px;
  position: absolute;
  background-color: #fff;
  top: 6px;
  left: 6px;
}
.sebox_List .sebox_Detail span {
  font-size: 16px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #282c33;
  line-height: 24px;
  margin-top: 24px;
}
.glbox_List {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.glbox_List p {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
}
.glbox_List span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
}
.glbox_List .glbox_Detail {
  margin-top: 59px;
  width: 1270px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}

.glbox_List .glbox_Detail .glbox_Detail_box {
  width: 390px;
  height: 182px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 50px;
  cursor: pointer;
}
.active {
  width: 390px;
  height: 182px;
  background-color: #ccc;
  border-radius: 10px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 50px;
}
.glbox_List .glbox_Detail .active .glbox_Detail_boxLeft {
  display: flex;
  flex-direction: column;
}
.glbox_List .glbox_Detail .active .glbox_Detail_boxLeft .glbox_Detail_boxLeftt {
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
  margin-bottom: 28px;
}
.glbox_List .glbox_Detail .active .glbox_Detail_boxLeft .glbox_Detail_boxLeftb {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 18px;
  width: 182px;
}
.glbox_List .glbox_Detail .active img {
  width: 84px;
  height: 84px;
}
.glbox_List .glbox_Detail .glbox_Detail_box .glbox_Detail_boxLeft {
  display: flex;
  flex-direction: column;
}
.glbox_List
  .glbox_Detail
  .glbox_Detail_box
  .glbox_Detail_boxLeft
  .glbox_Detail_boxLeftt {
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
  margin-bottom: 28px;
}
.glbox_List
  .glbox_Detail
  .glbox_Detail_box
  .glbox_Detail_boxLeft
  .glbox_Detail_boxLeftb {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 18px;
  width: 182px;
}
.glbox_List .glbox_Detail .glbox_Detail_box img {
  width: 84px;
  height: 84px;
}
.topFont {
  position: absolute;
  left: 9%;
  top: 120px;
  animation: topFont 2s;
}
@keyframes topFont {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.topFont .topFontO {
  font-size: 32px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
}
.topFont .topFontT {
  font-size: 40px;
  font-weight: 600;
  color: #0066ff;
  line-height: 40px;
  letter-spacing: 5px;
  margin: 23px 0;
}
.topFont .topFontTh {
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
  margin-bottom: 41px;
}
.headerTop {
  position: relative;
  display: flex;
  justify-content: space-around;
}
.headerTop .headerTopCenter {
  position: absolute;
  display: flex;
  width: 1349px;
  height: 134px;
  align-items: center;
  z-index: 1000;
  bottom: -47px;
  background: #f3f7fe;
  box-shadow: 0px 4px 16px 0px rgb(227 227 227 / 50%);
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  border: 1px solid #ffffff;
  justify-content: space-evenly;
}
.headerTop .headerTopCenter .headerTopBottom {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.headerTop .headerTopCenter .headerTopBottom .headerTopBottomFont {
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
}
.headerTop .headerTopCenter .headerTopBottom .headerTopBottomFonts {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  margin-top: 16px;
  line-height: 16px;
}
.border_parent {
  width: 90%;
  margin: auto;
}

.border_parent {
  width: 90%;
  margin: auto;
}
.slider_img {
  height: 492px;
  width: 100%;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_pc_box {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.product_pc_box .product_pc_boxDetail {
  width: 259px;
  height: 436px;
  background: #e9effa;
  border-radius: 10px;
  padding: 48px 28px 0px 28px;
  position: relative;
  animation: product_pc_boxDetail 2s;
}
@keyframes product_pc_boxDetail {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.product_pc_box .product_pc_boxDetail p {
  font-size: 24px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #282c33;
  line-height: 18px;
}
.product_pc_box .product_pc_boxDetail span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #545b66;
  line-height: 38px;
}
.product_pc_box .product_pc_boxDetail img {
  width: 187px;
  height: 187px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.product_mobile_content {
  margin-top: 86px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  animation: product_mobile_content 2s;
}
@keyframes product_mobile_content {
  0% {
    opacity: 0;
    transform: translate3d(0, -200%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.product_mobile_img {
  width: 506px;
  height: 523px;
  margin-left: 30%;
  margin-top: 29px;
  animation: product_mobile_img 2s;
}
@keyframes product_mobile_img {
  0% {
    opacity: 0;
    transform: translate3d(-200%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.product_mobile_title {
  font-weight: bold;
  text-align: center;
}
.product_pcs {
  display: flex;
  width: 90%;
  height: auto;
  margin: 20px auto;
  flex-direction: column;
}
.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: product_pc_one 2s;
}
@keyframes product_pc_one {
  0% {
    opacity: 0;
    transform: translate3d(-200%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.font_size_30 {
  font-size: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 48px;
}
.font_size_40 {
  font-size: 24px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #000000;
  margin: 39px 0 15px 0;
  line-height: 24px;
}
.font_size_10 {
  font-size: 16px;
  text-align: left;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
  margin-left: 92px;
  margin-right: 40px;
}
.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
  height: 465px;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
}

.product_spec_title {
  margin-top: 97px;
  margin-bottom: 64px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}
.product_Server {
  width: 100%;
  padding: 91px 0 116px 0;
  align-items: center;
  margin: auto;
}
.product_mobiless {
  width: 100%;
  padding: 70px 0 37px 0;
  align-items: center;
  margin: 20px auto;
  background: #f6f7fa;
}
.product_mobile {
  width: 100%;
  height: 552px;
  align-items: center;
  margin: 20px auto;
  background: #f6f7fa;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  /* line-height: 38px; */
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.font_size_24 {
  font-size: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 48px;
}
</style>